import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface TECProductVairantModal {
    isLoading: boolean;
    value: Values;
    parentProductId: string;
}
export interface Values {
    uri: string
    products: Product[]
    pagination: Pagination
    properties: {}
  }
  
  export interface Product {
    uri: string
    id: string
    productNumber: string
    customerProductNumber: any
    customerUnitOfMeasure: any
    productTitle: string
    urlSegment: string
    canonicalUrl: string
    manufacturerItem: string
    packDescription: string
    unitListPrice: number
    unitListPriceDisplay: string
    priceFacet?: number
    smallImagePath: string
    mediumImagePath: string
    largeImagePath: string
    imageAltText: string
    isDiscontinued: boolean
    quoteRequired: boolean
    minimumOrderQty: number
    isSponsored: boolean
    trackInventory: boolean
    configurationType: string
    canConfigure: boolean
    canAddToCart: boolean
    canAddToWishlist: boolean
    canShowPrice: boolean
    canShowUnitOfMeasure: boolean
    isVariantParent: boolean
    variantTypeId?: string
    salePriceLabel: string
    cantBuy: boolean
    allowZeroPricing: boolean
    brand: any
    productLine: any
    unitOfMeasures: UnitOfMeasure[]
    score: number
    detail: Detail
    images: Image[]
    documents: Document[]
    attributeTypes: AttributeType[]
    properties: Properties
  }
  
  export interface UnitOfMeasure {
    id: string
    unitOfMeasure: string
    unitOfMeasureDisplay: string
    description: string
    qtyPerBaseUnitOfMeasure: number
    roundingRule: string
    isDefault: boolean
  }
  
  export interface Detail {
    name: string
    modelNumber: string
    sku: string
    upcCode: string
    unspsc: string
    productCode: string
    priceCode: string
    sortOrder: number
    multipleSaleQty: number
    canBackOrder: boolean
    roundingRule: string
    replacementProductId: any
    isHazardousGood: boolean
    hasMsds: boolean
    isSpecialOrder: boolean
    isGiftCard: boolean
    isSubscription: boolean
    subscription: any
    allowAnyGiftCardAmount: boolean
    taxCode1: string
    taxCode2: string
    taxCategory: string
    vatCodeId: any
    shippingClassification: string
    shippingLength: number
    shippingWidth: number
    shippingHeight: number
    shippingWeight: number
    configuration?: Configuration
  }
  
  export interface Configuration {
    configSections: ConfigSection[]
    hasDefaults: boolean
    isKit: boolean
  }
  
  export interface ConfigSection {
    id: string
    sectionName: string
    label: string
    sortOrder: number
    sectionOptions: SectionOption[]
  }
  
  export interface SectionOption {
    id: string
    productId?: string
    name: string
    description: string
    price: number
    selected: boolean
    sortOrder: number
    quantity: number
  }
  
  export interface Image {
    id: string
    sortOrder: number
    name: string
    imageType: string
    smallImagePath: string
    mediumImagePath: string
    largeImagePath: string
    imageAltText: string
  }
  
  export interface Document {
    id: string
    name: string
    description: string
    filePath: string
    documentType: string
  }
  
  export interface AttributeType {
    id: string
    name: string
    label: string
    isFilter: boolean
    isComparable: boolean
    isSearchable: boolean
    includeOnProduct: boolean
    sortOrder: number
    attributeValues: AttributeValue[]
  }
  
  export interface AttributeValue {
    id: string
    value: string
    valueDisplay: string
    sortOrder: number
  }
  
  export interface Properties {}
  
  export interface Pagination {
    currentPage: number
    page: number
    pageSize: number
    defaultPageSize: number
    totalItemCount: number
    numberOfPages: number
    pageSizeOptions: number[]
    sortOptions: SortOption[]
    sortType: string
    nextPageUri: string
    prevPageUri: any
  }
  
  export interface TECProductVaiantParameter extends ApiParameter{
    productIds?: string;
    expand?: string[];
  }
  export interface SortOption {
    displayName: string
    sortType: string
  }

  const productsUrl = "/api/v2/products";
  const variantchildren = "variantchildren";

  export async function ProductVaiantDetail(parameter: TECProductVaiantParameter) {
    const newParameter = {...parameter};
    delete newParameter.productIds;
    const response = await get<TECProductVairantModal>(
        `${productsUrl}/${parameter.productIds}/${variantchildren}`,
        newParameter
    );
    return response;
}